import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=1de05b8f&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de05b8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de05b8f')) {
      api.createRecord('1de05b8f', component.options)
    } else {
      api.reload('1de05b8f', component.options)
    }
    module.hot.accept("./uploadFile.vue?vue&type=template&id=1de05b8f&scoped=true", function () {
      api.rerender('1de05b8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QBR/uploadFile.vue"
export default component.exports